export default __webpack_public_path__ + "static/media/blueStarFav.7cecec8b.svg";